import { createSlice } from '@reduxjs/toolkit';
import { submitFeedbackThunk } from './thunks/submit-feedback-thunk';

export interface FeedbackState {
  isOpen: boolean;
  isSending: boolean;
  lastSent: string | null;
  error: string | null;
}

const initialState: FeedbackState = {
  isOpen: false,
  isSending: false,
  lastSent: null,
  error: null,
};

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    openFeedback: (state) => {
      state.isOpen = true;
      state.error = null;
    },
    closeFeedback: (state) => {
      state.isOpen = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitFeedbackThunk.pending, (state) => {
        state.isSending = true;
        state.error = null;
      })
      .addCase(submitFeedbackThunk.fulfilled, (state, action) => {
        state.isSending = false;
        state.lastSent = action.payload.timestamp;
        state.isOpen = false;
        state.error = null;
      })
      .addCase(submitFeedbackThunk.rejected, (state, action) => {
        state.isSending = false;
        state.error = action.error.message || 'Failed to submit feedback';
      });
  },
});

export const {
  openFeedback,
  closeFeedback,
} = feedbackSlice.actions;
export default feedbackSlice.reducer;
